var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaintenance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 83.32 84.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#7da2fe;}.cls-2,.cls-3,.cls-4,.cls-5{stroke:#fff;stroke-miterlimit:10;}.cls-3{fill:url(#linear-gradient);}.cls-6{fill:#1f82f7;}.cls-4{fill:rgba(255,255,255,.2);}.cls-5{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 3.44,
    y1: 59.58,
    x2: 46.52,
    y2: 59.58,
    gradientTransform: "translate(-35.53 34.82) rotate(-45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#386aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b86f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 37.64,
    y1: 40.4,
    x2: 50.69,
    y2: 40.4,
    gradientTransform: "translate(-15.63 43.06) rotate(-45)",
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M77.4,68.33L32.68,26.8c-1.48-1.38-2.02-3.49-1.37-5.41s.94-4.03,.79-6.22c-.53-7.62-6.66-13.9-14.26-14.61-2.39-.22-4.68,.08-6.78,.83-.35,.12-.42,.59-.13,.83l9.03,7.45c1.72,1.42,1.96,3.98,.54,5.69l-5.28,6.41c-1.42,1.72-3.98,1.97-5.7,.55L1.23,15.47c-.27-.23-.7-.05-.71,.31v.11c-.23,7.19,4.4,13.77,11.35,15.66,2.95,.8,5.82,.78,8.43,.1,1.8-.47,3.71,.14,4.97,1.5l42.05,45.27c1.4,1.47,3.28,2.21,5.16,2.21s3.64-.69,5.04-2.09c2.83-2.83,2.78-7.43-.11-10.2Zm-2.21,7.88c-1.48,1.47-3.86,1.47-5.34,0-1.47-1.48-1.47-3.86,0-5.33,1.48-1.47,3.86-1.47,5.34,0,1.47,1.48,1.47,3.86,0,5.33Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M10.08,84.34c-2.64,0-5.12-1.02-6.98-2.88-3.85-3.85-3.85-10.11,0-13.95,23.79-23.79,29.59-29.58,31-31-.17-1.68,.41-3.34,1.63-4.55,1.06-1.06,2.48-1.65,3.99-1.65s2.93,.59,3.99,1.65l.22,.22L63.7,12.42c.61-.61,1.09-1.36,1.4-2.23l1.6-4.37,8.69-4.28,.28-.09c.44-.14,.9-.21,1.36-.21,1.28,0,2.55,.54,3.48,1.47l1.33,1.33c1.31,1.31,1.79,3.17,1.26,4.86l-.08,.27-4.29,8.68-4.37,1.6c-.86,.32-1.61,.79-2.23,1.4l-19.76,19.76,.22,.22c2.2,2.2,2.2,5.78,0,7.98-1.06,1.06-2.48,1.65-3.99,1.65-.19,0-.37,0-.56-.03-1.43,1.43-7.25,7.25-31,31-1.86,1.86-4.34,2.88-6.98,2.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M10.08,83.1c-2.31,0-4.48-.89-6.1-2.52-3.36-3.36-3.36-8.84,0-12.2,0,0,31.43-31.43,31.45-31.45-.33-1.43,.07-2.99,1.18-4.1,.83-.83,1.94-1.29,3.11-1.29h0c1.18,0,2.28,.46,3.11,1.29l1.1,1.1,20.64-20.64c.74-.74,1.31-1.64,1.69-2.68l1.43-3.9,8.16-4.02,.18-.06c.32-.1,.66-.15,1-.15,.95,0,1.9,.4,2.61,1.11l1.33,1.33c.98,.98,1.35,2.36,.96,3.61l-.06,.18-4.02,8.15-3.91,1.43c-1.03,.38-1.93,.95-2.67,1.69l-20.64,20.64,1.1,1.1c1.72,1.72,1.72,4.51,0,6.23-.83,.83-1.94,1.29-3.11,1.29-.34,0-.67-.04-.99-.11-.02,.02-31.45,31.45-31.45,31.45-1.62,1.63-3.79,2.52-6.1,2.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M19.64,34.08h9.25c.84,0,1.53,.68,1.53,1.53v45.94c0,2.74-2.22,4.97-4.97,4.97h-2.37c-2.74,0-4.97-2.22-4.97-4.97V35.61c0-.84,.68-1.53,1.53-1.53Z",
    transform: "translate(49.74 .5) rotate(45)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 22.84,
    y: 36.84,
    width: 1.92,
    height: 40.34,
    rx: 0.77,
    ry: 0.77,
    transform: "translate(47.29 -.13) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.59,
    y: 40.59,
    width: 1.92,
    height: 40.34,
    rx: 0.77,
    ry: 0.77,
    transform: "translate(51.03 -1.68) rotate(45)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 35.95,
    y: 38.47,
    width: 16.43,
    height: 3.86,
    rx: 1.56,
    ry: 1.56,
    transform: "translate(41.5 -19.4) rotate(45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M76.06,14.88l-2.98,1.09c-1.37,.5-2.58,1.27-3.57,2.26l-22.39,22.39-3.19-3.19,22.39-22.39c1-1,1.76-2.21,2.26-3.57l1.09-2.98,7.09-3.5c.35-.11,.79,.03,1.11,.34l1.33,1.33c.32,.32,.46,.76,.34,1.11l-3.5,7.09Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/maintenance.24264a1e22176c0c8c54d4626ff8f430.svg";
export { ForwardRef as ReactComponent };